import { render } from "./SupplierModal.vue?vue&type=template&id=70f57f7d&scoped=true"
import script from "./SupplierModal.vue?vue&type=script&lang=js"
export * from "./SupplierModal.vue?vue&type=script&lang=js"

import "./SupplierModal.vue?vue&type=style&index=0&id=70f57f7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f57f7d"]])

export default __exports__